export type AttendanceAction = "checkin" | "checkout";

export function getAttendanceConfirmationCopy(action: AttendanceAction) {
  return action === "checkin"
    ? { title: "ยืนยันเช็คอินเข้างาน", body: "กรุณาตรวจสอบว่าต้องการบันทึกเวลาเข้างานของบัญชี LINE นี้" }
    : { title: "ยืนยันเช็คเอาท์ออกงาน", body: "กรุณาตรวจสอบว่าต้องการบันทึกเวลาออกงานของบัญชี LINE นี้" };
}

export function canOpenAttendanceConfirmation(action: AttendanceAction, enabled: boolean) {
  return enabled && (action === "checkin" || action === "checkout");
}

export function openAttendanceConfirmation(action: AttendanceAction, enabled: boolean) {
  return canOpenAttendanceConfirmation(action, enabled) ? action : null;
}

export function cancelAttendanceConfirmation() {
  return null;
}

export function confirmAttendanceAction(action: AttendanceAction | null, run: (action: AttendanceAction) => void) {
  if (action) run(action);
  return null;
}
